import logoComponayPlaceholder from '@/public/images/skyline.png';
import styles from '@/styles/highlight-jobs.module.css';
import { HighlightJob } from '@/types/job';
import Image from 'next/image';
import ShareJobButton from '../modals/share-job-button';
import { useCurrentWidth } from '../search/useDebounce';
import { IconPcd } from '../jobs/icon-pdc';
import Link from '@/components/link-with-utms';
import { nameMask } from '@/utils/name-mask';
import { formatJobTitle } from '@/utils/format-job-title';

export default function HighlightJobCard({ data }: HighlightJobCardProps) {
  if (!data.title) {
    console.log('HighlightJobCard render', { data });
  }
  let jobTitleDisplay = formatJobTitle(data.title);

  jobTitleDisplay = jobTitleDisplay.replace(/\( /g, `(`).replace(/\)/g, `)`);

  if (/\w+\/\w+/g.test(jobTitleDisplay)) {
    jobTitleDisplay = jobTitleDisplay.split(`/`).join(` / `);
  }

  const windowWidth = useCurrentWidth();

  if (windowWidth < 768 && jobTitleDisplay.length > 34) {
    const words = jobTitleDisplay.split(` `);
    let lastWordIndex = Math.min(words.length - 1, 4);
    while (words[lastWordIndex - 1].length < 2 && lastWordIndex > 1) {
      lastWordIndex--;
    }
    if (words[lastWordIndex - 1].length <= 2) {
      lastWordIndex--;
    }
    jobTitleDisplay = words.slice(0, lastWordIndex).join(` `);
    jobTitleDisplay = jobTitleDisplay.slice(0, jobTitleDisplay.length) + `...`;
  }

  const renderLocation = Boolean(data.city && (data.stateAbbreviation || data.state));

  const companyNameFormatted = data.companyName.toLowerCase().includes('empresa confidencial')
    ? 'Empresa Confidencial'
    : nameMask(data.companyName);

  return (
    <div className={styles.highlight_box}>
      <Link href={`/vagas/emprego/${data.id}-vaga-de-${data.slug}?utm_content=destaque`}>
        <div className={styles.highlight_company}>
          <div className={styles.top}>
            <div className={styles.img_container}>
              <Image
                width={58}
                height={58}
                // O logo vem da API na proporcao que a empresa mandou — o
                // Lighthouse pegou um 250x327 sendo espremido neste quadrado de
                // 58x58. `contain` mostra o logo inteiro, com folga nas laterais,
                // em vez de distorcer a marca de quem anuncia.
                style={{ objectFit: `contain` }}
                src={data.companyLogo || logoComponayPlaceholder}
                alt={`Logo da empresa ${companyNameFormatted}`}
              />
            </div>
            <p className={styles.highlight_responsibility}>
              {jobTitleDisplay} {data.pcd && <IconPcd />}
            </p>
          </div>
          <p className={styles.highlight_company_name}>{companyNameFormatted}</p>
        </div>

        {renderLocation && (
          <div className={styles.highlight_data}>
            <p className={styles.highlight_localization}>
              {data.city} - {data.stateAbbreviation || data.state}
            </p>
          </div>
        )}
        <div className={styles.highlight_info}>
          <p>{data.contactInfo}</p>
        </div>
      </Link>
      <ul className={styles.highlight_share}>
        <li>
          <ShareJobButton
            link={`${process.env.NEXT_PUBLIC_BASE_REF}/vagas/emprego/${data.id}-vaga-de-${data.slug}`}
            utmContent="destaque"
          />
        </li>
      </ul>
    </div>
  );
}

interface HighlightJobCardProps {
  data: HighlightJob;
}
